import { render } from "./CampagnaIntegrazione.vue?vue&type=template&id=4c2f9b9e&scoped=true"
import script from "./CampagnaIntegrazione.vue?vue&type=script&lang=js"
export * from "./CampagnaIntegrazione.vue?vue&type=script&lang=js"

import "./CampagnaIntegrazione.vue?vue&type=style&index=0&id=4c2f9b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2f9b9e"]])

export default __exports__